export default {
	properties: [
		{
			text: 'Descripcion',
			key: 'description',
			type: 'text',
		},
		{
			text: 'Valor',
			key: 'value',
			type: 'number',
			is_price: true,
		},
	],
	singular_model_name_spanish: 'Costo Extra',
	plural_model_name_spanish: 'Costos Extra',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}